// extracted by mini-css-extract-plugin
export default {"fieldset":"PopupForm_fieldset__FXEz9","label":"PopupForm_label__h2HXY","text":"PopupForm_text__JQxCP","input":"PopupForm_input__voSbT","error":"PopupForm_error__m+7lF"};